const ROLE_NAV = {
  super_admin: ['/', '/policies', '/slabs', '/employees', '/employee-portal-users', '/approvals', '/profile-corrections', '/hospital-management', '/term-coverages', '/claims', '/term-claims', '/endorsements', '/reports', '/notifications', '/audit', '/hrms-sync'],
  hr_manager: ['/', '/policies', '/slabs', '/employees', '/term-coverages', '/claims', '/term-claims', '/endorsements', '/reports', '/notifications', '/approvals'],
  hr_executive: ['/', '/employees', '/claims', '/term-claims', '/notifications'],
  finance: ['/', '/reports', '/notifications'],
  employee: ['/', '/my-family', '/hospitals', '/my-profile', '/claims', '/notifications'],
  insurance_coordinator: ['/', '/policies', '/employees', '/term-coverages', '/claims', '/term-claims', '/endorsements', '/reports', '/notifications'],
};

export function canAccessRoute(role, path) {
  if (!role) return false;
  const allowed = ROLE_NAV[role] || ['/'];
  return allowed.some((p) => (p === '/' ? path === '/' : path.startsWith(p)));
}

export function getNavItems(role) {
  const all = [
    { to: '/', label: role === 'employee' ? 'My Coverage' : 'Dashboard' },
    { to: '/policies', label: 'Policies' },
    { to: '/slabs', label: 'Age Slabs' },
    { to: '/employees', label: 'Employees' },
    { to: '/employee-portal-users', label: 'Portal Logins' },
    { to: '/approvals', label: 'Approvals' },
    { to: '/profile-corrections', label: 'Profile Corrections' },
    { to: '/hospital-management', label: 'Hospital Management' },
    { to: '/my-family', label: 'Add Family' },
    { to: '/hospitals', label: 'Network Hospitals' },
    { to: '/my-profile', label: 'My Profile' },
    { to: '/term-coverages', label: 'Term Coverages' },
    { to: '/claims', label: 'Mediclaim Claims' },
    { to: '/term-claims', label: 'Term Claims' },
    { to: '/endorsements', label: 'Endorsements' },
    { to: '/reports', label: 'Reports' },
    { to: '/notifications', label: 'Notifications' },
    { to: '/hrms-sync', label: 'HRMS Sync' },
    { to: '/audit', label: 'Audit Log' },
  ];
  return all.filter((item) => canAccessRoute(role, item.to));
}
